import { useCallback } from 'react';
import type { NavState } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/nav-state.tsx';
import type { NavigationContainer } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/navigation-container.tsx';
import type { NavigationLayer } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/navigation-layer.tsx';
import type { Stage } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/types.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

type AnalyticsBase = {
	/** id of the view if applicable e.g. boardid */
	itemId?: string;

	/** Name of the view, e.g. board, customShortcut */
	itemType: string;
	navState: NavState;
	stage: Stage;
	navigationLayer: NavigationLayer;
	navigationContainer: NavigationContainer;

	/** Is the item in the More menu */
	isInMore: boolean;

	/** number of child items (e.g. for shortcuts) */
	childCount?: number;

	isFullscreen?: boolean;
};
export type Analytics = AnalyticsBase;

export const useNavigationItemAnalyticsWithContext = (analytics: Analytics) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return useCallback(
		(context?: Pick<Analytics, 'childCount'>) => {
			const analyticsEvent = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'navigationItem',
			});
			const { childCount } = context ?? {};
			fireUIAnalytics(analyticsEvent, 'projectNavigationTab', {
				...analytics,
				childCount: childCount ?? analytics.childCount,
			});
		},
		[analytics, createAnalyticsEvent],
	);
};

export const useNavigationItemAnalytics = (analytics: Analytics) => {
	const triggerAnalytics = useNavigationItemAnalyticsWithContext(analytics);
	return useCallback(() => {
		triggerAnalytics();
	}, [triggerAnalytics]);
};
